// var $ = require('jquery');
module.exports = {
	init: function () {
		$('.accordion .title').on('click', function (evt) {
			evt.preventDefault();
			
			$(this).parent().toggleClass('active');
			$(this).parent().find('.content').slideToggle('300');
			
		});
	}
}